import { defineComponent as _defineComponent } from 'vue'
import { Typo, TypoVariant } from '@travelata-libs/ui-kit';
import { pluralize } from '@travelata-libs/utils';
import { useCheckInDateRangeStore, FLEXIBLE_DAYS } from '@entities/searchCriteria/checkInDate';
import SerpTrackingService from '@fr/vue/pages/serp/analytics/yandexAnalytics/serpTrackingService';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlexibleDays',
  props: {
    modelPrefix: null,
    isMobile: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({(event: 'change', value: { daysFlexible: number }): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelPrefix?: string, isMobile?: boolean }



const { checkInDateRange } = useCheckInDateRangeStore(props.modelPrefix || '');
const trackingService = new SerpTrackingService();

const setFlexibleDays = (days: number) => {
    const daysFlexible = days === checkInDateRange.value?.daysFlexible ? 0: days
    emits('change', { daysFlexible });
    if(daysFlexible) {
        trackingService.flexibleDaysClick({ daysFlexible })
    }
}


return { __sfc: true,props, emits, checkInDateRange, trackingService, setFlexibleDays, Typo, pluralize, FLEXIBLE_DAYS }
}

})